/* =========================================================
   eSplicito · capa de ahorro del carrito
   Se carga DESPUÉS de cart-drawer-custom.js y solo agrega
   el precio tachado, el chip "Ahorra $X", la franja verde
   y la línea de "DESCUENTO ESPECIAL" del pie.

   No modifica ninguna función del archivo original: escucha
   los cambios del listado y vuelve a pintar encima.
   ========================================================= */
(function () {
  'use strict';

  var CACHE = {};    // handle -> { variantId: {price, compare} }
  var PENDING = {};  // handle -> Promise
  var observer = null;
  var timer = null;
  var painting = false;

  /* Mismo formato que el carrito original: $195.000 */
  function fmt(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(/,/g, '.');
  }

  /* Precio tachado por producto. Se pide una sola vez y queda en caché. */
  function getVariants(handle) {
    if (CACHE[handle]) return Promise.resolve(CACHE[handle]);
    if (PENDING[handle]) return PENDING[handle];

    PENDING[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var map = {};
        if (p && p.variants) {
          for (var i = 0; i < p.variants.length; i++) {
            var v = p.variants[i];
            map[v.id] = {
              price: v.price,
              compare: v.compare_at_price || 0
            };
          }
        }
        CACHE[handle] = map;
        delete PENDING[handle];
        return map;
      })
      .catch(function () {
        CACHE[handle] = {};
        delete PENDING[handle];
        return {};
      });

    return PENDING[handle];
  }

  function paint(cart, data) {
    var ahorroTotal = 0;
    painting = true;
    if (observer) observer.disconnect();

    for (var i = 0; i < data.length; i++) {
      var it = data[i].item;
      var map = data[i].map || {};
      var info = map[it.variant_id];
      var compare = (info && info.compare) ? info.compare : 0;

      /* Guarda: solo cuenta si el tachado es REALMENTE mayor.
         Hay productos con compare_at menor al precio y eso
         mostraría un "ahorro" negativo. */
      var ahorroLinea = 0;
      if (compare > it.final_price) {
        ahorroLinea = (compare - it.final_price) * it.quantity;
      }
      ahorroTotal += ahorroLinea;

      var row = document.querySelector('.cs-row[data-key="' + it.key + '"]');
      if (!row) continue;

      /* --- chip "Ahorra $X" --- */
      var chip = row.querySelector('.cs-chip');
      if (ahorroLinea > 0) {
        if (!chip) {
          chip = document.createElement('div');
          chip.className = 'cs-chip';
          var meta = row.querySelector('.cs-meta');
          if (meta && meta.parentNode) {
            meta.parentNode.insertBefore(chip, meta.nextSibling);
          } else {
            var info_el = row.querySelector('.cs-info');
            if (info_el) info_el.appendChild(chip);
          }
        }
        chip.textContent = 'Ahorra ' + fmt(ahorroLinea);
      } else if (chip && chip.parentNode) {
        chip.parentNode.removeChild(chip);
      }

      /* --- precio tachado + precio actual --- */
      var pr = row.querySelector('.cs-price');
      if (pr) {
        var ahora = '<span class="cs-now">' + fmt(it.final_line_price) + '</span>';
        if (ahorroLinea > 0) {
          pr.innerHTML = '<span class="cs-was">' + fmt(compare * it.quantity) + '</span>' + ahora;
        } else {
          pr.innerHTML = ahora;
        }
      }
    }

    /* --- franja verde de ahorro --- */
    var strip = document.getElementById('cs-save-strip');
    var sval = document.getElementById('cs-save-val');
    if (strip && sval) {
      if (ahorroTotal > 0) {
        strip.style.display = 'flex';
        sval.textContent = fmt(ahorroTotal);
      } else {
        strip.style.display = 'none';
      }
    }

    /* --- línea del pie ---
       Si Shopify aplica un descuento real (escalera activa) manda ese.
       Si no, muestra el ahorro contra el precio de lista. */
    var real = cart.total_discount || 0;
    var mostrado = real > 0 ? real : ahorroTotal;
    var etiqueta = real > 0 ? 'DESCUENTO APLICADO' : 'DESCUENTO HALLOWEEN';

    var dl = document.getElementById('cs-disc-line');
    var dv = document.getElementById('cs-disc-val');
    var dt = document.getElementById('cs-disc-txt');
    if (dl && dv) {
      if (mostrado > 0) {
        dl.style.display = 'flex';
        dv.textContent = '− ' + fmt(mostrado);
        if (dt) dt.textContent = etiqueta;
      } else {
        dl.style.display = 'none';
      }
    }

    var tot = document.getElementById('cs-total');
    if (tot) tot.textContent = fmt(cart.total_price);

    painting = false;
    watch();
  }

  function refresh() {
    if (painting) return;
    if (!document.getElementById('cs-cart-drawer')) return;

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        if (!cart.items || cart.items.length === 0) {
          paint(cart, []);
          return;
        }
        var jobs = cart.items.map(function (it) {
          return getVariants(it.handle).then(function (map) {
            return { item: it, map: map };
          });
        });
        return Promise.all(jobs).then(function (data) {
          paint(cart, data);
        });
      })
      .catch(function () { /* si falla, el carrito sigue funcionando igual */ });
  }

  function schedule() {
    if (painting) return;
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  function watch() {
    var items = document.getElementById('cs-items');
    if (!items) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(schedule);
    observer.observe(items, { childList: true });
  }

  function watchDrawer() {
    var drawer = document.getElementById('cs-cart-drawer');
    if (!drawer) return;
    var wasOpen = drawer.classList.contains('open');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('open');
      if (isOpen && !wasOpen) schedule();
      wasOpen = isOpen;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    watch();
    watchDrawer();
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
